// @flow

import React from 'react';
import { mapProps, type HOC } from 'recompose';
import glamorous from 'glamorous';
import SingleTeamButton from './SingleTeamButton';

type OuterProps = {
  awayTeamName: string,
  awayTeamId: number,
  awayTeamSelected: boolean,
  homeTeamName: string,
  homeTeamId: number,
  homeTeamSelected: boolean,
  onSelect: string => void
};

type InnerProps = {
  id1: string,
  id2: string,
  disabled1: boolean,
  disabled2: boolean,
  isHome1: boolean,
  isHome2: boolean,
  name1: string,
  name2: string,
  image1: string,
  image2: string,
  selected1: boolean,
  selected2: boolean,
  onSelect: string => void
};

const TeamSelectButtonContainer = glamorous.div({
  display: 'flex'
});

function TeamSelectButton({
  id1,
  id2,
  isHome1,
  isHome2,
  image1,
  image2,
  disabled1,
  disabled2,
  name1,
  name2,
  selected1,
  selected2,
  onSelect
}: InnerProps) {
  return (
    <TeamSelectButtonContainer>
      <SingleTeamButton
        id={id1}
        isHome={isHome1}
        name={name1}
        image={image1}
        onClick={onSelect}
        selected={selected1}
        disabled={disabled1}
      >
        {name1}
      </SingleTeamButton>
      <SingleTeamButton
        id={id2}
        isHome={isHome2}
        name={name2}
        image={image2}
        onClick={onSelect}
        selected={selected2}
        disabled={disabled2}
      >
        {name2}
      </SingleTeamButton>
    </TeamSelectButtonContainer>
  );
}

const enhancer: HOC<OuterProps, InnerProps> = mapProps(props =>
  props.countryCode === 'US'
    ? {
        id1: props.awayTeamId,
        id2: props.homeTeamId,
        isHome1: false,
        isHome2: true,
        disabled1: !!props.awayDisabled,
        disabled2: !!props.homeDisabled,
        name1: props.awayTeamName,
        name2: props.homeTeamName,
        selected1: props.awayTeamSelected,
        selected2: props.homeTeamSelected,
        image1: props.awayImage,
        image2: props.homeImage,
        onSelect: props.onSelect
      }
    : {
        id1: props.homeTeamId,
        id2: props.awayTeamId,
        isHome1: true,
        isHome2: false,
        name1: props.homeTeamName,
        name2: props.awayTeamName,
        disabled1: !!props.homeDisabled,
        disabled2: !!props.awayDisabled,
        selected1: props.homeTeamSelected,
        selected2: props.awayTeamSelected,
        image1: props.homeImage,
        image2: props.awayImage,
        onSelect: props.onSelect
      }
);

export default enhancer(TeamSelectButton);
